import { useEffect, useState } from "react";
import {
  Activity,
  Building2,
  CheckCircle2,
  Clock,
  PhoneCall,
  ShieldAlert,
  Users,
} from "lucide-react";
import { useTranslation } from "react-i18next";
import { api } from "@/lib/api";
import { KPICard, PageHeader, StatusPill } from "@/components/uiext";
import { useEngineAliveDebounced } from "@/lib/useEngineAlive";

export default function PlatformOverview() {
  const { t } = useTranslation();
  const [stats, setStats] = useState(null);
  useEffect(() => {
    const load = () => api.get("/platform/stats").then((r) => setStats(r.data)).catch(() => {});
    load();
    const t = setInterval(load, 5000);
    return () => clearInterval(t);
  }, []);
  // Phase 6ak (Hotfix Z.4) — debounce engine_alive flicker.
  const engineState = useEngineAliveDebounced(stats?.engine_alive, 3, stats);
  const engineKind =
    engineState === "up" ? "ok" : engineState === "down" ? "danger" : "warn";
  const engineLabel =
    engineState === "up"
      ? t("dashboard.engine.up", "Engine UP")
      : engineState === "down"
      ? t("dashboard.engine.down", "Engine DOWN")
      : t("dashboard.engine.checking", "Checking…");
  return (
    <div data-testid="page-platform-overview">
      <PageHeader
        title="Platform Overview"
        subtitle="Tenants, users, traffic, engine health."
        icon={Activity}
        actions={<StatusPill kind={engineKind}>{engineLabel}</StatusPill>}
      />
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
        <KPICard label="Tenants" value={stats?.total_orgs ?? "—"} icon={Building2} hint={stats ? `${stats.active_orgs} active` : null} testid="kpi-total-orgs" />
        <KPICard label="Pending" value={stats?.pending_orgs ?? "—"} icon={Clock} accent="warn" hint="awaiting approval" testid="kpi-pending-orgs" />
        <KPICard label="Suspended" value={stats?.suspended_orgs ?? "—"} icon={ShieldAlert} accent="danger" testid="kpi-suspended-orgs" />
        <KPICard label="Users" value={stats?.total_users ?? "—"} icon={Users} testid="kpi-total-users" />
        <KPICard label="Active calls" value={stats?.active_calls ?? "—"} icon={PhoneCall} hint="across all tenants" testid="kpi-plat-active-calls" />
        <KPICard label="Calls (24h)" value={stats?.total_calls_24h ?? "—"} icon={CheckCircle2} testid="kpi-plat-calls-24h" />
      </div>
    </div>
  );
}
